import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap} from "gsap";
import {KennethMustDie} from "../KennethMustDie";
import {SimpleReelModel, SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";
import {SPECIAL_SYMBOL_NAMES, X_NUDGE_ANIMATIONS} from "../server/IKMDData";
import {KMDSymbol} from "../reels/KMDSymbol";
import {KMDSound} from "../sound/KMDSound";
import {KMDGameMode} from "../server/KMDGameMode";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class KMDReelStartPresentation implements FlowStatePresentation {

    public start(flowStateController: FlowStateController): void {
        const tl: gsap.core.Timeline = gsap.timeline({onComplete: () => flowStateController.finish()}),
            allSymbolsSpecialReel: SimpleReelModelSymbolData[] = KennethMustDie.specialReelView.reel.stopSymbols;
        let delay: number = 0.06,
            extraDelay: number = 0;

        // #470
        KennethMustDie.mgIntro.stopIntro();

        KennethMustDie.xWaysReveal.hideAll();

        // #331
        KennethMustDie.miniPayTable.onNewBet();
        KennethMustDie.reelView.reelModels.forEach((reel: SimpleReelModel) => {
            reel.setInteractiveSymbols(false);
        });
        KennethMustDie.specialReelView.reel.setInteractiveSymbols(false);

        allSymbolsSpecialReel.forEach((symbol: SimpleReelModelSymbolData, idx: number) => {
            if (symbol.name === SPECIAL_SYMBOL_NAMES.X_NUDGE_WILD) {
                tl.add([
                    () => {
                        (symbol.positionable as KMDSymbol).removeMultiplierOnXNudge();

                        const stopSymbols: SimpleReelModelSymbolData[] = KennethMustDie.reelView.reelModels[idx + 1].stopSymbols;
                        stopSymbols.forEach((sym: SimpleReelModelSymbolData) => {
                            (sym.positionable as KMDSymbol).visible = true;
                        });
                    },
                    (symbol.positionable as KMDSymbol).setState(X_NUDGE_ANIMATIONS.UP_3_STEP_REVERSE).timeScale(2)
                ], 0);
            }
        });

        tl.add(KennethMustDie.multipliersChain.startSpin());

        // #235
        KennethMustDie.soundPlayer.playSound(KMDSound.REELS_SPINNING, 1, Number.MAX_VALUE);

        extraDelay += tl.totalDuration();

        tl.add([
            () => {
                const multipliers: number[][] = KennethMustDie.model.data.multiplier;

                KennethMustDie.reelView.toggleMask(true);
                KennethMustDie.specialReelView.toggleMask(true);

                if ((KennethMustDie.model.data.nextMode === KMDGameMode.NORMAL || KennethMustDie.model.data.mode === KMDGameMode.NORMAL_AVALANCHE) || (KennethMustDie.model.data.mode.indexOf("NORMAL") > -1 && KennethMustDie.model.data.nextMode.indexOf("NORMAL") === -1)) {
                    KennethMustDie.SYMBOLS_NUM_PER_REEL = [2, 4, 5, 6, 2];
                } else {
                    KennethMustDie.SYMBOLS_NUM_PER_REEL = [2, 3 + (multipliers[1][3]), 3 + (multipliers[2][3]), 3 + (multipliers[3][3]), 2];
                }
                KennethMustDie.possibleWays.updateWays();

                KennethMustDie.car.stopCar();
            },
            KennethMustDie.reelView.reelModels[0].start(false),
            KennethMustDie.specialReelView.reel.start(true)
        ], extraDelay);
        tl.add(KennethMustDie.reelView.reelModels[1].start(false), delay + extraDelay);
        tl.add(KennethMustDie.reelView.reelModels[2].start(false), (delay * 2) + extraDelay);
        tl.add(KennethMustDie.reelView.reelModels[3].start(false), (delay * 3) + extraDelay);
        tl.add(KennethMustDie.reelView.reelModels[4].start(false), (delay * 4) + extraDelay);

        if (KennethMustDie.apiPlugin.settings.get(APISetting.FAST_SPIN, false)) {
            tl.timeScale(2);
        }
    }
}